<div class="tt-w-dim-teaser">
  <div v-for="dimConfig in subdims" class="tt-w-dim-teaser__item">
    <tt-summary-custom-range v-if="dimConfig.displayType === 'VISUAL' && dimConfig.dim.type === 2"
                             class="tt-w-dim-teaser__dim"
                             :averageRating="dimConfig.dim.average"
                             :headingLevel="teaserConfig.headingLevel"
                             :showMiddleLabel="true"
                             :values="dimConfig.dim.values">
      <span class="tt-w-dim-teaser__heading-txt">{{dimConfig.label}}</span>
      <span class="tt-w-dim-teaser__reviews-count" v-html="dimConfig.numReviewsMsg"></span>
    </tt-summary-custom-range>
    <tt-dim-distribution  v-if="dimConfig.displayType === 'DISTRIBUTION' && dimConfig.dim.type === 2"
                          class="tt-w-dim-teaser__dim"
                          :headingLevel="teaserConfig.headingLevel"
                          :showMiddleLabel="true"
                          :label="dimConfig.label"
                          :values="dimConfig.dim.values">
      <span class="tt-w-dim-teaser__heading-txt">{{dimConfig.label}}</span>
      <span class="tt-w-dim-teaser__reviews-count" v-html="dimConfig.numReviewsMsg"></span>
    </tt-dim-distribution>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/widgets/subdimension-teaser/subdimension-teaser.html